import { NgModule } from '@angular/core';
import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from '../shared/shared.module';
import { LoginService } from './services/login.service';
import { DispatcherSignupComponent } from './dispatcher-signup/dispatcher-signup.component';
import { LoginComponent } from './login/login.component';
import { DriverSignUpComponent } from './driver-signup/driver-signup.component';
import { CongratsModalComponent } from './onboarding/congrats-modal/congrats-modal.component';
import { OnBoardingComponent } from './onboarding/onboarding.component';
import { PromoComeModalComponent } from './driver-signup/promo-come-modal/promo-come-modal.component';
import { CommonSingupPopupComponent } from './common-singup-popup/common-singup-popup.component';

@NgModule({
  declarations: [
    LoginComponent,
    DispatcherSignupComponent,
    DriverSignUpComponent,
    OnBoardingComponent,
    CongratsModalComponent,
    PromoComeModalComponent,
    CommonSingupPopupComponent,
  ],
  imports: [
    AuthRoutingModule,
    SharedModule,
],
exports: [
    LoginComponent
  ],
  providers: [LoginService]
})
export class AuthModule { }
